import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config';
import { useEffect, useState } from 'react';
import { FirebaseContext } from '../context/FirebaseContext';

export const FirebaseProvider = ({ children }) => {
  const [ready, setReady] = useState(false);

  const firebaseConfig = {
    apiKey: 'AIzaSyAkWTGRHrgirgCk83uSaTT8dZyxZqRJnxY',
    authDomain: 'instant-meals.firebaseapp.com',
    projectId: 'instant-meals',
    storageBucket: 'instant-meals.appspot.com',
    messagingSenderId: '816689555837',
    appId: '1:816689555837:web:321a46529c15126160c414',
    measurementId: 'G-10YHM2NS6Z'
  };

  const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

  const auth = getAuth(app);
  const remoteConfig = getRemoteConfig(app);

  useEffect(() => {
    const init = async () => {
      try {
        remoteConfig.settings = {
          minimumFetchIntervalMillis: 3600000
        };

        remoteConfig.defaultConfig = {
          dev_api_endpoint: '',
          staging_api_endpoint: '',
          prod_api_endpoint: '',
          dev_api_key: ''
        };

        await fetchAndActivate(remoteConfig);
      } catch (err) {
        //eslint-disable-next-line
        console.warn('Remote config init failed:', err);
      } finally {
        setReady(true);
      }
    };

    init();
  }, [remoteConfig]);

  return (
    <FirebaseContext.Provider value={{ auth, remoteConfig, ready }}>
      {children}
    </FirebaseContext.Provider>
  );
};
